import en from '../../../lang/en-us';
import SearchInput from '../../../lib/SearchInput';
import { connect } from 'react-redux';
import { RootStateType } from '../../../redux-store/reducers';
import { useEffect } from 'react';
import { getTrackStatus, getCommercialTrackStatus } from '../../../redux-store/actions/nct';
import { useState } from 'react';
import moment from 'moment';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import NoFoliosFound from '../makeNct/NoFoliosFound';
import { TableColumn, TableWithCollapse } from '../../../lib/DataTable';
import { useTableWithCollapse } from '../../../lib/DataTable/customHooks';
import { useMemo } from 'react';
import { useCallback } from 'react';
import { FaqLink } from '../makeNct';
import { getDateString, TRACK_STATUS, TRACK_STATUS_TYPES } from '../../../utils/constants';
import SegmentedControl from '../../common/segmented-control';
import { getQueryParams } from '../../../utils/utilityFunctions';
import { IsAllow } from '../../../redux-store/types/portfolio';

const { dashboard, trackStatus } = en;

export const SUCCESS = 'Success';
export const REJECTED = 'Rejected';
export const INPROGRESS = 'In Progress';
export const COMPLETED = 'Completed';

export const FP = 'First Purchase';
export const AP = 'Additional Purchase';
export const REDEMPTION = 'Redemption';
export const SWITCH = 'SWITCH';

export const getStatus = (value: string) => {
    const uppercaseValue = (value || '').toUpperCase();
    if (uppercaseValue === 'COMPLETED' || uppercaseValue === 'SUCCESS') {
        return COMPLETED;
    }
    if (uppercaseValue === 'PENDING' || uppercaseValue === 'ACCEPTED') {
        return INPROGRESS;
    }
    if (uppercaseValue === 'ERROR' || uppercaseValue === 'ERRORS') {
        return REJECTED;
    }
    return value;
};

function TrackStatus(props: any) {
    const tab = getQueryParams(props.location.search)[0];
    const [trackList, setList] = useState<any>([]);
    const [filterText, setFilterText] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);
    const currentTab = parseInt(tab) !== NaN && [1, 2].includes(parseInt(tab)) ? parseInt(tab) : 1;
    const columns = useCallback(
        (tab): TableColumn[] => {
            const extraColumnsForTransactions: TableColumn[] = [
                {
                    field: 'amcName',
                    headerName: 'Fund house',
                },
                {
                    field: 'folio',
                    headerName: 'Folio',
                },
            ];
            return [
                {
                    field: 'Sno',
                    headerName: 'S NO.',
                    valueGetter: ({ index = 0 }) =>
                        (index + 1).toLocaleString('en-US', {
                            minimumIntegerDigits: 2,
                            useGrouping: false,
                        }),
                },
                ...(currentTab === 2 ? extraColumnsForTransactions : []),
                {
                    field: 'requestTypeDesc',
                    headerName: currentTab === 2 ? 'TRANSACTION TYPE' : 'SERVICE REQUEST TYPE',
                },
                { field: 'reqId', headerName: 'TRANSACTION ID' },
                {
                    field: 'requestTime',
                    headerName: 'DATE',
                    valueGetter: (params) => getDateString(params?.row?.requestTime),
                },
                {
                    field: 'status',
                    headerName: 'STATUS',
                    renderCell: ({ row }) => {
                        const status = getStatus(row.status);
                        return (
                            <div
                                style={{
                                    color: 'white',
                                    padding: 5,
                                    textAlign: 'center',
                                    borderRadius: 10,
                                    background:
                                        status === COMPLETED
                                            ? '#6FCFC3'
                                            : status === INPROGRESS
                                                ? '#F2994A'
                                                : '#EB5757',
                                }}
                            >
                                {status}
                            </div>
                        );
                    },
                },
                {
                    field: '',
                    headerName: '',
                    renderCell: ({ row }) => (
                        <div
                            className="track-view-link"
                            onClick={() =>
                                props.history.push(
                                    `${tab === 2 ? 'track-for-transaction' : 'track-for-nct'}/${row.reqId
                                    }`,
                                )
                            }
                        >
                            {Boolean(Object.keys(row?.rtaResponse ?? {}).length) && (
                                <a>
                                    {' '}
                                    View
                                    <KeyboardArrowRightIcon />
                                </a>
                            )}
                        </div>
                    ),
                },
            ];
        },
        [currentTab],
    );

    const filteredData = useMemo(() => {
        if (filterText) {
            return trackList.filter((_ele: any) => _ele.reqId.toString().includes(filterText));
        }
        return trackList;
    }, [filterText, trackList]);

    const { tableColumns, tableRows } = useTableWithCollapse({
        rows: filteredData,
        columns: columns(currentTab),
        loading,
    });

    useEffect(() => {
        async function fetchData() {
            setLoading(true);
            try {
                const { pan, pekrn, reqId, mobile } = props;
                let response: any =
                    currentTab === 1
                        ? await props.getTrackStatus({
                            pan,
                            pekrn,
                            mobile,
                        })
                        : await props.getCommercialTrackStatus({
                            pan,
                            pekrn,
                            mobile,
                        });
                const { requests } = response.body;
                setList(requests.map((request: any) => {
                    if (request.requestType === "NEW_KYC_REGISTER") {
                        return {
                            ...request,
                            "status": "SUCCESS"
                        }
                    }
                    return request;
                }));
            } catch (e: any) {
                alert(e.message);
            } finally {
                setLoading(false);
            }
        }
        fetchData();
    }, [currentTab]);

    const TrackSegment = useCallback(
        () => (
            <SegmentedControl
                additionalClasses="portfolio-details-tabs portfolio-demat-tabs track-status-tabs"
                segments={TRACK_STATUS_TYPES}
                selectedSegmentIndex={currentTab - 1}
                onSegmentChanged={(index) => {
                    props.history.replace(`/portal/track?tab=${index + 1}`);
                }}
            />
        ),
        [currentTab],
    );

    return (
        <div className="curved-bg">
            {props.ftTransactions === IsAllow.YES ? (
                <TrackSegment />
            ) : (
                <h2 className="heading">
                    <a
                        href="#"
                        style={{
                            visibility: 'hidden',
                        }}
                    >
                        <img src="/images/left-arrow-black.svg" alt="icon" />
                    </a>
                    {dashboard.dashboardLeft.link4}
                </h2>
            )}
            <div className="curved-bg-content curved-bg-table-outer">
                <div className="curved-bg-content-table">
                    <div style={{ maxWidth: '415px', width: '100%' }}>
                        <SearchInput
                            darkmode={true}
                            placeholder={trackStatus.searchWithTransaction}
                            onChange={(e: any) => setFilterText(e.target.value)}
                            value={filterText}
                        />
                    </div>
                    {useMemo(
                        () => (
                            <div className="curved-table-content">
                                {!!tableRows.length || loading ? (
                                    <TableWithCollapse rows={tableRows} columns={tableColumns} />
                                ) : (
                                    <NoFoliosFound info={en.common.noRecordsFound} />
                                )}
                            </div>
                        ),
                        [tableRows, tableColumns],
                    )}
                </div>
                <FaqLink section={TRACK_STATUS} />
                <div className="curved-bg-content-inner-bottom"></div>
            </div>
        </div>
    );
}

export default connect(
    ({ authReducer, portfolio }: RootStateType) => ({ ...authReducer, ...portfolio }),
    { getTrackStatus, getCommercialTrackStatus },
)(TrackStatus);
